var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSummaryRepoBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 182,
    viewBox: "0 0 404 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_460_8314",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 404,
    height: 182
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 404,
    height: 181,
    rx: 20,
    fill: "#E36867"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_460_8314)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 404,
    height: 182.398,
    rx: 20,
    fill: "#A5B837"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98,
    cy: 85.5,
    rx: 98,
    ry: 85.5,
    transform: "matrix(-1 0 0 1 221 5.5)",
    fill: "url(#paint0_linear_460_8314)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_460_8314",
    x1: 224.053,
    y1: 193.367,
    x2: 150.945,
    y2: 92.4685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSummaryRepoBackground);
export default __webpack_public_path__ + "static/media/AiSummaryRepoBackground.f01f7a27e244f2f91d96be433c04beac.svg";
export { ForwardRef as ReactComponent };